<template>
    <div class="admin-page-header" :class="{ 'admin-page-header_inline': inline }">
        <h1 class="admin-page-header__title">{{ title }}</h1>

        <div class="admin-page-header__control">
            <!-- Поле можно убрать: на странице оборудования поиск живёт отдельной строкой
                 (BaseToolsSearch с подсказкой и хоткеем), и второе поле рядом сбивало бы. -->
            <VSearchField
                class="admin-page-header__search"
                placeholder="Поиск"
                with-timeout
                v-if="!hideSearch"
                @input="$emit('search', search)"
                v-model="search"
            ></VSearchField>

            <!-- Пустая подпись означает «кнопки нет»: так страница скрывает действие,
                 не зная о существовании этой разметки. Раньше в этом случае рисовалась
                 пустая зелёная кнопка. -->
            <VButton class="button_green admin-page-header__button" v-if="button" @click="$emit('button')">
                {{ button }}
            </VButton>
        </div>
    </div>
</template>
<script>
// Components
import VButton from './VButton/VButton.vue';
import VSearchField from './VInput/VSearchField.vue';

// Other
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
    components: {
        VButton,
        VSearchField,
    },
})
class VContentHeaderDefault extends Vue {
    @Prop({ type: String, default: 'Заголовок' })
    title;

    @Prop({ type: String, default: 'Создать' })
    button;

    @Prop({ type: Boolean, default: false })
    hideSearch;

    // Заголовок и кнопка в одну строку, кнопка прижата вправо. По умолчанию выключено:
    // на остальных страницах кнопка стоит под заголовком, и менять это нечем оправдать.
    @Prop({ type: Boolean, default: false })
    inline;

    search = '';
}

export default VContentHeaderDefault;
</script>
<style lang="scss">
.admin-page-header {
    margin: 24px 36px;

    &__control {
        display: flex;
    }

    &__search {
        flex-grow: 1;
        margin: 0 24px 0 0;
    }

    &__title {
        margin: 0 0 24px 0;
    }

    // Заголовок слева, действие справа — одной строкой. Отступ снизу у заголовка
    // при этом лишний: он разводил бы строку по высоте.
    &_inline {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        flex-wrap: wrap;

        .admin-page-header__title {
            margin: 0;
        }

        .admin-page-header__control {
            flex-shrink: 0;
        }
    }
}
</style>
